var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRouteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 24.5C8.75 22.6333 10.5 20.9619 10.5 18.9C10.5 16.8381 8.933 15.1667 7 15.1667C5.067 15.1667 3.5 16.8381 3.5 18.9C3.5 20.9619 5.25 22.6333 7 24.5ZM7 24.5H20.4167C22.0275 24.5 23.3333 23.1942 23.3333 21.5833C23.3333 19.9725 22.0275 18.6667 20.4167 18.6667H17.5M21 12.8333C22.75 10.9667 24.5 9.2952 24.5 7.23333C24.5 5.17147 22.933 3.5 21 3.5C19.067 3.5 17.5 5.17147 17.5 7.23333C17.5 9.2952 19.25 10.9667 21 12.8333ZM21 12.8333H16.9167C15.3058 12.8333 14 14.1392 14 15.75C14 17.3608 15.3058 18.6667 16.9167 18.6667H18.2",
    stroke: "#8E97CD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRouteIcon);
export default __webpack_public_path__ + "static/media/route-icon.472ada47094eda780bf506d57ee68ec7.svg";
export { ForwardRef as ReactComponent };